import { render, staticRenderFns } from "./DOIs.vue?vue&type=template&id=b5647fe8&"
import script from "./DOIs.vue?vue&type=script&lang=js&"
export * from "./DOIs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports